export default "__VITE_ASSET__xkV_enj0__"